const PublicJsonQuery = {
  getAnnouncement: _ => {
    return fetch('/announcement.json').then(res => res.json());
  }
};

export default PublicJsonQuery;



// WEBPACK FOOTER //
// ./src/api/public_json/query.js